import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {WidgetData} from "../../../../../../../../core/shared/widget/widget-data";
import {WidgetFactory} from "../../../../../../../../core/shared/widget/service/widget.factory";


@Component({
    selector: 'ei-import-type-basic-component',
    templateUrl: 'ei-import-type-basic.component.html',
    standalone: false
})
export class EiImportTypeBasicComponent implements OnInit, OnChanges {

    @Input() importTypeId: number;

    initialized: boolean;
    importTypeBasic: WidgetData;

    private builtForId: number;

    ngOnInit() {
        this.initComponent();
        this.initialized = true;
    }

    initComponent() {
        if (!this.importTypeId) {
            return;
        }
        // Skip rebuild on every change-detection pass; only rebuild when the parent id actually changes.
        if (this.importTypeBasic && this.builtForId === this.importTypeId) {
            return;
        }
        this.importTypeBasic = WidgetFactory.createWidgetEntityData(
            'ei.importType.basic.data.widget',
            'Importtyp',
            'ei.EiImportType',
            this.importTypeId
        );
        this.builtForId = this.importTypeId;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!this.initialized) {
            return;
        }
        this.initComponent();
    }

}
